// @ts-nocheck
import { useCallback } from 'react';
import { supabase } from '../../supabaseClient';
import type { Session } from '@supabase/supabase-js';

export type AuditActionType =
  | 'user_role_update'
  | 'user_activate'
  | 'user_deactivate'
  | 'user_bulk_role_update'
  | 'user_bulk_activate'
  | 'user_bulk_deactivate'
  | 'bulk_email_send'
  | 'topic_create'
  | 'topic_update'
  | 'topic_delete'
  | 'subscription_create'
  | 'subscription_delete'
  | 'subscription_bulk_delete'
  | 'subscription_import'
  | 'notification_delete'
  | 'notification_bulk_delete'
  | 'contact_status_update'
  | 'contact_delete'
  | 'contact_bulk_delete'
  | 'news_create'
  | 'news_update'
  | 'news_delete'
  | 'settings_update'
  | 'media_upload'
  | 'media_delete'
  | 'media_bulk_delete';

export type AuditResourceType =
  | 'user'
  | 'topic'
  | 'subscription'
  | 'notification'
  | 'contact'
  | 'news'
  | 'settings'
  | 'media';

export interface AuditLogDetails {
  [key: string]: any;
  old_value?: any;
  new_value?: any;
  count?: number;
  email_subject?: string;
  email_recipients?: number;
  [key: string]: any;
}

/**
 * Hook to log admin actions to the audit log
 */
export function useAuditLog(session: Session | null) {
  const logAction = useCallback(
    async (
      actionType: AuditActionType,
      resourceType: AuditResourceType,
      resourceId: string | string[],
      details?: AuditLogDetails
    ) => {
      if (!session?.user?.id) {
        console.warn('Cannot log audit action: No session');
        return;
      }

      try {
        // Get IP address and user agent from browser if available
        const ipAddress = (window as any).clientIP || null;
        const userAgent = navigator.userAgent || null;

        const resourceIdStr = Array.isArray(resourceId) ? resourceId.join(',') : resourceId;

        const { error } = await supabase.from('admin_audit_log').insert({
          admin_id: session.user.id,
          action_type: actionType,
          resource_type: resourceType,
          resource_id: resourceIdStr,
          details: details || {},
          ip_address: ipAddress,
          user_agent: userAgent,
        });

        if (error) {
          console.error('Failed to log audit action:', error);
          // Don't throw - audit logging failures shouldn't break the main action
        }
      } catch (err) {
        console.error('Error logging audit action:', err);
        // Don't throw - audit logging failures shouldn't break the main action
      }
    },
    [session]
  );

  return { logAction };
}

